module.exports = __webpack_public_path__ + "static/media/logOut.04a04731.svg";